import * as cornerstone from '@cornerstonejs/core';
import * as cornerstoneTools from '@cornerstonejs/tools';

/**
 * Publishes `window.cornerstone` / `window.cornerstoneTools` for the Cypress suite.
 *
 * OHIF 3.8 exposed these; the 3.9 merge dropped them, and the fork restored the
 * assignment inside `extensions/cornerstone/src/init.tsx`. It lives here instead,
 * because nothing about it is upstream's concern — it exists purely so the e2e
 * harness can reach into the running app — and a patch in an upstream file has to be
 * re-applied and re-verified at every merge.
 *
 * Not test-only in the "strip it from production" sense: the smoke suite runs against
 * the same production bundle CI builds and deploys (see README-smoke.md), so gating
 * this behind a dev flag would make the bundle under test differ from the bundle
 * shipped — which is the failure mode the smoke setup exists to avoid.
 *
 * Covered by `cypress/support/viewer/viewport.ts`, which asserts
 * `expect(cornerstone, 'window.cornerstone').to.exist` before every viewport wait.
 */
export function exposeCornerstoneGlobals(target: Window & typeof globalThis = window) {
  (target as unknown as Record<string, unknown>).cornerstone = cornerstone;
  (target as unknown as Record<string, unknown>).cornerstoneTools = cornerstoneTools;
}
